import { gql } from '@apollo/client';

export const CREATE_DIVISION = gql`
  mutation CreateDivisionMutation(
    $group_id: String
    $company_id: String
    $division_name: String
    $user: String
  ) {
    createDivision(
      group_id: $group_id
      company_id: $company_id
      division_name: $division_name
      user: $user
    )
  }
`;

export const UPDATE_DIVISION = gql`
  mutation UpdateDivisionMutation(
    $group_id: String
    $company_id: String
    $updated_division: JSON
    $original_division: JSON
    $user: String
  ) {
    updateDivision(
      group_id: $group_id
      company_id: $company_id
      updated_division: $updated_division
      original_division: $original_division
      user: $user
    )
  }
`;

export const DELETE_DIVISION = gql`
  mutation DeleteDivisionMutation(
    $group_id: String
    $company_id: String
    $division_id: String
    $division_name: String
    $delete_subdivisions: [JSON]
    $delete_sites: [JSON]
    $user_email: String
  ) {
    deleteDivision(
      group_id: $group_id
      company_id: $company_id
      division_id: $division_id
      division_name: $division_name
      delete_subdivisions: $delete_subdivisions
      delete_sites: $delete_sites
      user_email: $user_email
    )
  }
`;

export const ARCHIVE_DIVISION = gql`
  mutation ArchiveDivisionMutation(
    $group_id: String
    $company_id: String
    $division_id: String
    $archive_subdivisions: [JSON]
    $archive_sites: [JSON]
    $user_email: String
  ) {
    archiveDivision(
      group_id: $group_id
      company_id: $company_id
      division_id: $division_id
      archive_subdivisions: $archive_subdivisions
      archive_sites: $archive_sites
      user_email: $user_email
    )
  }
`;

export const UNARCHIVE_DIVISION = gql`
  mutation UnarchiveDivisionMutation(
    $group_id: String
    $company_id: String
    $division_id: String
    $unarchive_subdivisions: [JSON]
    $unarchive_sites: [JSON]
    $user_email: String
  ) {
    unarchiveDivision(
      group_id: $group_id
      company_id: $company_id
      division_id: $division_id
      unarchive_subdivisions: $unarchive_subdivisions
      unarchive_sites: $unarchive_sites
      user_email: $user_email
    )
  }
`;
